import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { Body2 } from 'stories/elements/Typography/Text'
import _useTranslation from 'lib/hooks/_useTranslation'

const BorderContainer = styled.div`
    width: 400px;
    height: 335px;
    position: relative;
    border-radius: 40px;
    background: linear-gradient(135deg, #6c3ebc, #8bbdff);
    padding: 10px;
    box-shadow: 0px 20px 30px 0px #7b84e080;
    @media (max-width: 940px) {
        border-radius: 32px;
        padding: 5px;
    }
`

const AssetWrapper = styled.div`
    width: 100%;
    height: 100%;
    background: #000000;
    border-radius: 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 30px;
        background: linear-gradient(159.54deg, rgba(87, 103, 214, 0.2) 0%, rgba(247, 50, 110, 0.2) 100%);
        z-index: 0;
    }
`

const ContentContainer = styled.div`
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const QuestionText = styled(Body2)`
    all: unset;
    color: ${theme.colors.white};
    text-align: center;
    padding-bottom: 30px;
    font-size: 24px;
    max-width: 380px;
    font-family: var(--font-inter);
    font-weight: 650;
    line-height: 30px;
    letter-spacing: 0px;
    @media (max-width: 940px) {
        font-size: 22px;
        line-height: 28px;
    }
`

const OptionCardsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 0px 25px;
    width: 100%;
    max-width: 360px;
    @media (max-width: 940px) {
        padding: 0px;
        gap: 15px;
    }
`

const OptionCard = styled.div`
    border-radius: 14px;
    background: linear-gradient(102.61deg, rgba(87, 103, 214, 0.2) 1.56%, rgba(113, 19, 129, 0.2) 97.23%);
    border: 2px solid #ffffff1a;
    padding: 28px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;
`

const OptionText = styled(Body2)`
    font-family: var(--font-inter);
    color: ${theme.colors.white};
    font-weight: 450 !important;
    text-align: center;
    font-size: 21px;
    letter-spacing: 0.37px;
`

const QuizzesAsset: React.FC = () => {
    const { t } = _useTranslation('homepage')

    return (
        <BorderContainer>
            <AssetWrapper>
                <ContentContainer>
                    <QuestionText>{t('homepage/quizzesQuestion')}</QuestionText>
                    <OptionCardsContainer>
                        <OptionCard>
                            <OptionText>{t('homepage/quizzesOptionTrue')}</OptionText>
                        </OptionCard>
                        <OptionCard>
                            <OptionText>{t('homepage/quizzesOptionFalse')}</OptionText>
                        </OptionCard>
                    </OptionCardsContainer>
                </ContentContainer>
            </AssetWrapper>
        </BorderContainer>
    )
}

export default QuizzesAsset
